import { Permission } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import {
  RFIOrganization,
  useOrganizationsTableContext,
} from '../../../../OrganizationsTableContext'
import { useSoftRemoveRfiOrganizationMutation } from 'schema'

export function useRemoveOptions(): RemoveRowActionOptions<RFIOrganization> {
  const { refetch } = useOrganizationsTableContext()
  const [removeOrganization] = useSoftRemoveRfiOrganizationMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveRFIOrganization: {
        organization: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreRFIOrganization,
    disabled: ({ requestsForInformation }) =>
      !!requestsForInformation.length
        ? {
            message:
              "Organizations cannot be deleted if they are associated with one or more RFI's",
          }
        : false,
    onRemove: async ({ id }) => {
      await removeOrganization({ variables: { id } })
      refetch()
    },
  }
}
